import { LoadingButton } from "@mui/lab";
import { TableCell, TableRow } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useCraneDriver } from "../CraneDriverProvider";

export const CraneTableActionRow = () => {
  const {
    assignedLoads,
    submittingBasketId,
    submittingMaterialIds,
    submitBasket,
  } = useCraneDriver();
  const { t } = useTenantTranslation();

  return (
    <TableRow>
      <TableCell
        sx={{
          minWidth: { xs: 56, md: 72, lg: 96 },
          maxWidth: 120,
        }}
      />
      {assignedLoads.map((basket) => (
        <TableCell
          key={`action-${basket.load_basket_id}`}
          align="center"
          sx={{
            padding: { xs: 1, md: 1.5, lg: 2 },
            minWidth: { xs: 280, md: 350, lg: 420 },
            maxWidth: { lg: 500 },
          }}
        >
          <LoadingButton
            variant="contained"
            color="primary"
            size="large"
            loading={submittingBasketId === basket.load_basket_id}
            disabled={
              submittingBasketId !== null || submittingMaterialIds.size > 0
            }
            onClick={() => void submitBasket(basket.load_basket_id)}
            sx={{
              fontSize: { xs: 14, md: 16, lg: 20 },
              minWidth: { xs: 100, md: 120, lg: 140 },
              height: { xs: 48, md: 52, lg: 56 },
              fontWeight: "bold",
            }}
          >
            {t("complete")}
          </LoadingButton>
        </TableCell>
      ))}
    </TableRow>
  );
};
